
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cinemas/[slug]",
      function () {
        return require("private-next-pages/cinemas/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cinemas/[slug]"])
      });
    }
  